import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { PersonNameChangeCommandDataForm } from './PersonNameChangeCommandDataForm'

export function PersonNameChangeCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.crm.useChangeNameActions')({
    personId: ownerId,
    tenantId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.PersonNameChangeCommandData"
      title={translate('nameChangeButton.button')}
      {...props}
      commandDataForm={PersonNameChangeCommandDataForm}
      submit={submit}
    />
  )
}
